import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { Input, CustomButton, Modifiers } from '@fw-nextgen/fw-components';
import ForgotPasswordConfirmation from './ForgotPasswordConfirmation';

import ForgotPasswordFormFields from './ForgotPasswordFormFields';
import ForgotPasswordFormStore from '@app/src/components/authentication/forgot-password-page/store/ForgotPasswordFormStore';
import ROUTES from '@app/src/common/constants/routeUrls';

import AuthWindow from '../../components/AuthWindow';
import AuthWindowLogo from '../../components/AuthWindowLogo';

const ForgotPasswordForm = () => {
  const { current: store } = useRef(new ForgotPasswordFormStore());
  const { loading, isSend, form } = store;

  const setEmail = (value: string) => {
    form.email.setValue(value);
  };

  return (
    <AuthWindow>
      <form className="auth-window__form auth-window__form_center-vertically">
        <AuthWindowLogo className="auth-window__logo" />
        {isSend ? (
          <ForgotPasswordConfirmation email={form.email.value} />
        ) : (
          <>
            <h5 className="auth-window__heading">
              <FormattedMessage id="forgot.pass.form.heading" />
            </h5>
            <Input
              type="email"
              {...ForgotPasswordFormFields.email}
              value={form.email.value}
              error={form.errors.email}
              onChange={setEmail}
              placeholder="forgot.pass.form.email.placeholder"
            />
            <CustomButton
              modifiers={[Modifiers.SMALL]}
              className="auth-window__button"
              value="button.send.instructions"
              onClick={store.sendToken}
              disabled={!form.isValid}
              loading={loading}
              actionText="spinner.text.sending"
            />
            <Link className="auth-window__back-link" to={ROUTES.authPage.path}>
              <FormattedMessage id="button.back" />
            </Link>
          </>
        )}
      </form>
    </AuthWindow>
  );
};

export default observer(ForgotPasswordForm);
